import { render, staticRenderFns } from "./TabsList.vue?vue&type=template&id=17dd7196&scoped=true"
import script from "./TabsList.vue?vue&type=script&lang=js"
export * from "./TabsList.vue?vue&type=script&lang=js"
import style0 from "./TabsList.vue?vue&type=style&index=0&id=17dd7196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@neverendingsupport+vue2@2.7.22-template-compiler_@vue+compiler-sfc@_21fabc512e5cf77502f11efea17f021f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dd7196",
  null
  
)

export default component.exports